import Vue from 'vue'
import Vuex from 'vuex'

import system from './modules/system'
import admin from './modules/admin'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        system,
        admin
    }
})